import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const MemberLogin = () => {
  const { search } = useLocation();
  return <Navigate to={`/invite${search || ""}`} replace />;
};

export default MemberLogin;
